import { styled } from '@mui/material/styles';
import {
  Box,
  MenuItem,
  Button,
  DialogActions,
  Typography,
  FormControl,
} from '@mui/material';

export const StatusLabel = styled(Typography)({
  fontFamily: 'Outfit',
  fontWeight: 400,
  fontSize: '16px',
  color: 'var(--primary-navy)',
  marginBottom: '16px',
});

export const ChevronIcon = styled(Box)({
  position: 'absolute',
  top: '50%',
  right: '12px',
  transform: 'translateY(-50%)',
  fontSize: '16px',
  color: 'var(--instructions)',
  '&:hover': { cursor: 'pointer' },
});

export const StyledMenuItem = styled(MenuItem)({
  fontFamily: 'Outfit',
  fontSize: '16px',
  '&.Mui-selected': {
    backgroundColor: 'var(--inactive-btn)',
    color: 'var(--primary-blue)',
  },
});

export const ActionWrapper = styled(Box)({
  justifyContent: 'center',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});

export const StyledActions = styled(DialogActions)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  marginLeft: '32px',
  width: '100%',
  padding: 0,
});

export const ConfirmButton = styled(Button)<{ colorValue: string }>(
  ({ colorValue }) => ({
    backgroundColor: colorValue,
    textTransform: 'none',
    fontFamily: 'Outfit',
    fontSize: '16px',
    fontWeight: 400,
    color: 'var(--bg-color)',
    border: '1px solid',
    borderColor: colorValue,
    borderRadius: '8px',
    width: '130px',
    marginRight: '8px',
    '&:hover': {
      backgroundColor: colorValue,
      filter: 'brightness(0.85)',
    },
    '&.Mui-disabled': {
      backgroundColor: 'var(--warning-disabled)',
      color: 'var(--bg-color)',
      border: '1px solid var(--inactive-border)',
      borderRadius: '8px',
      textTransform: 'none',
      opacity: 1,
      cursor: 'not-allowed',
    },
  })
);

export const DialogContainer = styled(Box)<{ paddingRight?: string }>(
  ({ paddingRight = '16px' }) => ({
    position: 'relative',
    padding: '16px',
    paddingRight: paddingRight,
  })
);

export const StatusFieldContainer = styled(Box)({
  marginLeft: '32px',
  marginBottom: '8px',
});

export const FormControlStyled = styled(FormControl)({
  width: '100%',
  margin: 0,
});

export const ReasonFieldContainer = styled(Box)({
  marginTop: '16px',
});
